interface HospitalMapProps {
  lat: number
  lon: number
  name: string
  height?: string | number
}

export const HospitalMap = ({ lat, lon, name, height = 300 }: HospitalMapProps) => {
  const zoom = 13

  // Use OpenStreetMap iframe embed - more reliable than static images
  const embedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${lon - 0.01},${lat - 0.01},${lon + 0.01},${lat + 0.01}&layer=mapnik&marker=${lat},${lon}`

  const handleViewFullMap = () => {
    window.open(
      `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=${zoom}/${lat}/${lon}`,
      '_blank'
    )
  }

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <iframe
        width="100%"
        height={height}
        frameBorder="0"
        scrolling="no"
        marginHeight={0}
        marginWidth={0}
        src={embedUrl}
        style={{
          border: '1px solid #ccc',
          borderRadius: '4px',
          display: 'block',
        }}
        title={`Map showing location of ${name}`}
      />
      <div style={{ marginTop: 8, textAlign: 'right' }}>
        <a
          onClick={(e) => {
            e.preventDefault()
            handleViewFullMap()
          }}
          href="#"
          style={{
            fontSize: '12px',
            color: '#1677ff',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          View Larger Map →
        </a>
      </div>
    </div>
  )
}
